import { u as d, A as E } from "./ConfigService-a05d127e.mjs";
const R = function(e, r) {
  let o = {};
  if (e)
    if (e.PreferenceService)
      ({ PreferenceService: o } = e);
    else
      return e.PreferenceService = o, r(o);
  return o;
}(
  typeof window == "object" && window || typeof globalThis == "object" && globalThis || void 0,
  function(e) {
    let r = {
      locale: "",
      currency: ""
    };
    const o = () => r, l = (t) => {
      r = Object.assign(r, t);
    };
    return e.getPreferences = o, e.setPreferences = l, e;
  }
), u = (e, r) => {
  const [o, ...l] = e, t = d.getConfigs(), n = {
    message: null,
    "log.level": r,
    IMAGE_TAG: t.IMAGE_TAG,
    "log.type": "CONSOLE_LOGS"
  }, g = {
    component: o.component,
    product: o.product
  }, c = !o.component && !o.product;
  return r === "ERROR" ? (n["err.message"] = l, n.message = c ? [] : [g]) : n.message = c ? l : [g, ...l], n["log.logger"] = o != null && o.page ? o == null ? void 0 : o.page : o == null ? void 0 : o.component, typeof window < "u" ? n : JSON.stringify(n);
}, b = {
  log: (...e) => console.log(u(e, "LOG")),
  info: (...e) => console.info(u(e, "INFO")),
  warn: (...e) => console.warn(u(e, "WARN")),
  error: (...e) => console.error(u(e, "ERROR")),
  debug: (...e) => console.debug(u(e, "DEBUG"))
}, p = {
  log: () => {
  },
  info: () => {
  },
  warn: () => {
  },
  error: () => {
  },
  debug: () => {
  }
}, i = {
  DEBUG: 0,
  INFO: 1,
  WARN: 2,
  ERROR: 3
};
var v = Object.defineProperty, G = (e, r, o) => r in e ? v(e, r, { enumerable: !0, configurable: !0, writable: !0, value: o }) : e[r] = o, s = (e, r, o) => (G(e, typeof r != "symbol" ? r + "" : r, o), o);
const L = class f {
  constructor(r) {
    s(this, "loggerObj"), s(this, "log"), s(this, "info"), s(this, "warn"), s(this, "debug"), s(this, "error"), s(this, "logLevelsCondition", (t) => {
      const n = d.getConfigs();
      switch (t) {
        case "info":
          return !n.LOG_LEVEL || i[n.LOG_LEVEL] <= i.INFO;
        case "warn":
          return !n.LOG_LEVEL || i[n.LOG_LEVEL] <= i.WARN;
        case "debug":
          return !n.LOG_LEVEL || i[n.LOG_LEVEL] <= i.DEBUG;
        case "error":
          return !n.LOG_LEVEL || i[n.LOG_LEVEL] <= i.ERROR;
        case "log":
        default:
          return !0;
      }
    }), s(this, "callOrReturnLog", (t) => {
      const { devMode: n } = R.getPreferences();
      return n ? console[t] : (...g) => {
        if (!this.logLevelsCondition(t))
          return;
        const c = g.flat(), a = c[c.length - 1], O = a && typeof a == "object" && t in a;
        (O ? [a] : f.loggersArr).forEach((h) => {
          h[t](this.loggerObj, ...O ? c.slice(0, c.length - 1) : g);
        });
      };
    });
    var o, l;
    this.loggerObj = {
      product: "",
      component: "",
      sessionId: (l = (o = E.getSession()) == null ? void 0 : o.session) == null ? void 0 : l.id,
      ...r
    }, this.log = (() => this.callOrReturnLog("log"))(), this.info = (() => this.callOrReturnLog("info"))(), this.warn = (() => this.callOrReturnLog("warn"))(), this.debug = (() => this.callOrReturnLog("debug"))(), this.error = (() => this.callOrReturnLog("error"))();
  }
  static getInstance(r) {
    return new f(r);
  }
};
s(L, "loggersArr", [b, p]), s(L, "setLoggers", (...e) => {
  L.loggersArr = [...e];
});
let w = L;
const A = w;
export {
  A,
  b as m,
  R as s
};
//# sourceMappingURL=Logger-b1967205.mjs.map
